import Card from "../components/Card"
import Create from "../components/Svg/Create"
import Delete from "../components/Svg/Delete"
import DeleteModal from "../components/DeleteModal";
import { useState } from "react";
import Dots from "../components/Svg/Dots"
import useForm from "../useForm";
import UpdateBankDetailsModal from "../components/UpdateBankDetailsModal";
import useBank from "../useBank";

function BankDetails() {
    const [bankDeleteModal, setBankDeleteModal] = useState(false);
    const [updateBankDetailsModal, setUpdateBankDetailsModal] = useState(false);
    const {errmsg} = useForm();
    const {bankData} = useBank()

  return (
    <div className='bd-container'>
        <h6 className='bd-head'>
            Bank Details Information
        </h6>
       {errmsg ? <p>{errmsg }</p> :  <Card>
            <div className="bd-content">
                <div className="bd-content-group">
                    <div className="bdcg-head">
                        <h6 className="bdcg-header">
                            Currency
                        </h6>
                    </div>
                    <div className="bdcg-main">
                        <p>Naira</p>
                    </div>
                </div>
                <div className="bd-content-group">
                    <div className="bdcg-head">
                        <h6 className="bdcg-header">
                           Bank Account
                        </h6>
                    </div>
                    <div className="bdcg-main ba-main">
                        <p>{bankData.account_number} <span className="text-secondary">({bankData.account_name})</span></p>
                    </div>
                </div>
                <div className="bd-content-group">
                    <div className="bdcg-head">
                        <h6 className="bdcg-header">
                           Bank Name
                        </h6>
                        <div className="create-group" onClick={() => setUpdateBankDetailsModal(true)}>
                            <Create className="create" fill="#60B0F4"/>
                        </div>
                        <div className="delete-group" onClick={() => setBankDeleteModal(true)}>
                            <Delete className="delete" fill="#EB313C" />
                        </div>
                        <div className="menu-dots-group">
                            <Dots className="menu-dots" fill='black' />
                            <div className="options">
                            <div className="mb-create-group" onClick={() => setUpdateBankDetailsModal(true)}>
                            <Create className="create" fill="#60B0F4"/>
                            <h6>Edit Account</h6>
                        </div>
                        <hr />
                        <div className="mb-delete-group" onClick={() => setBankDeleteModal(true)}>
                            <Delete className="delete" fill="#EB313C" />
                            <h6>Delete</h6>
                        </div>
                            </div>
                        </div>
                    </div>
                    <div className="bdcg-main">
                        <p>{bankData.bank_name}</p>
                    </div>
                </div>
            </div>
        </Card>}
        <DeleteModal id={bankData.id} show={bankDeleteModal}
        onHide={() => setBankDeleteModal(false)}  ></DeleteModal>
        <UpdateBankDetailsModal id={bankData.id} show={updateBankDetailsModal}
        onHide={() => setUpdateBankDetailsModal(false)}  ></UpdateBankDetailsModal>
    </div>
  )
}

export default BankDetails